<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="idForm" name="nomForm">

        <div class="grid form-group">
          <div class="col-12 md:col-4 lg:col-4">
            <div class="div-form">
              <label>{{'LBL_CODIGO' | translate}}:</label>
              <input type="text" pInputText id="codigo"
                     name="nomCodigo"
                     autocomplete="off"
                     formControlName="codigo"
                     codigos-reactive
                     [maxLength]="8"
              >
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigo.invalid">
                {{ 'LBL_CODIGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>

          <div class="col-12 md:col-4 lg:col-4 md:col-offset-1 lg:col-offset-1">
            <div class="div-form">
              <label>{{'PROCESOPRODUCTIVO.LBL_VARIABLESINCID' | translate}}:</label>
              <input type="text" pInputText id="variableIncidencia"
                     name="nomVariableIncidencia"
                     autocomplete="off"
                     formControlName="variableIncidencia"
                     capitalize-reactive
                     [maxLength]="100"
              >
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.variableIncidencia.invalid">
                {{ 'PROCESOPRODUCTIVO.LBL_VARIABLESINCID' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>

          <div class="col-12 md:col-3 lg:col-3 pt-5">
            <div class="div-form">
              <p-checkbox formControlName="indicadorHabilitado" binary="true"></p-checkbox>
              <label class="pl-2">{{'LBL_HABILITADO' | translate}}</label>
            </div>
          </div>
        </div>


        <div class="grid form-footer-buttons">
          <div class="form-group col-12">
            <div *ngIf="!guardando">
              <button icon="fa fa-plus" label="{{'BTN_GUARDAR' | translate }}"
                      type="submit" *ngIf="!variableIncidencia"
                      pButton></button>
              <button icon="fa fa-plus" label="{{'BTN_ACTUALIZAR' | translate }}"
                      type="submit" *ngIf="variableIncidencia"
                      pButton></button>
            </div>
            <div *ngIf="guardando">
              <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
              <span>{{'LBL_GUARDANDO' | translate }}</span>
            </div>
          </div>
        </div>

      </form>
    </div>
  </div>

  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas" [loading]="carTabla" #dt
               [value]="lisVariablesIncidencias" selectionMode="single" dataKey="idVariableIncidencia"
               [paginator]="true" [rows]="10"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td class="table-break">{{row.codigo}}</td>
            <td class="table-break">{{row.variableIncidencia}}</td>
            <td class="text-center">
              <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
            </td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                        title="{{'BTN_EDITAR' | translate}}" pButton *ngIf="menu.editar"
                        (click)="editar(row)"></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

</div>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
